import React, { useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { Lightbox } from './Lightbox';

const allPhotos = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/12ordvan_bcdc.jpeg",
    title_fr: "Aménagement BCC - Vue d'ensemble",
    title_en: "BCC Landscaping - Overview",
    category_fr: "Aménagement",
    category_en: "Landscaping",
    category_key: "amenagement",
    location: "Kananga",
    client: "BCC Kananga"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/pnecsvke_jkm6.jpeg",
    title_fr: "Dalots en construction",
    title_en: "Culverts under construction",
    category_fr: "Assainissement",
    category_en: "Drainage",
    category_key: "assainissement",
    location: "RDC",
    client: ""
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/vv3f5qn8_jkm7.jpeg",
    title_fr: "Murs de soutènement en gabions",
    title_en: "Gabion retaining walls",
    category_fr: "Génie Civil",
    category_en: "Civil Engineering",
    category_key: "genie_civil",
    location: "RDC",
    client: ""
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/s4e1mph2_jkm4.jpeg",
    title_fr: "Canal de drainage principal",
    title_en: "Main drainage channel",
    category_fr: "Assainissement",
    category_en: "Drainage",
    category_key: "assainissement",
    location: "RDC",
    client: ""
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/vhonatp8_jkm3.jpeg",
    title_fr: "Système d'évacuation des eaux",
    title_en: "Water evacuation system",
    category_fr: "Assainissement",
    category_en: "Drainage",
    category_key: "assainissement",
    location: "RDC",
    client: ""
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/lhxni973_jkm8.jpeg",
    title_fr: "Fondation avec gabions",
    title_en: "Foundation with gabions",
    category_fr: "Génie Civil",
    category_en: "Civil Engineering",
    category_key: "genie_civil",
    location: "RDC",
    client: ""
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/awc8j13q_jkm9.jpeg",
    title_fr: "Analyses en laboratoire géotechnique",
    title_en: "Geotechnical laboratory analysis",
    category_fr: "Études",
    category_en: "Studies",
    category_key: "etudes",
    location: "RDC",
    client: ""
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/smtv48sg_jkm1.jpeg",
    title_fr: "Études sur le terrain",
    title_en: "Field studies",
    category_fr: "Études",
    category_en: "Studies",
    category_key: "etudes",
    location: "RDC",
    client: ""
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/2yxcpw5m_tp.jpeg",
    title_fr: "Terrassement et fondation",
    title_en: "Excavation and foundation",
    category_fr: "Génie Civil",
    category_en: "Civil Engineering",
    category_key: "genie_civil",
    location: "RDC",
    client: ""
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_jkm-engineering-rdc/artifacts/sphg59lx_jkm2.jpeg",
    title_fr: "Parc d'équipements de chantier",
    title_en: "Construction equipment yard",
    category_fr: "Équipements",
    category_en: "Equipment",
    category_key: "equipements",
    location: "RDC",
    client: ""
  },
  {
    id: 11,
    image: "https://customer-assets.emergentagent.com/job_7e1961ac-5810-49fb-bfe1-8dd4c900e77c/artifacts/v6iffpm4_pave3.jpeg",
    title_fr: "Équipe JKM en opération de forage",
    title_en: "JKM team during drilling operation",
    category_fr: "Forage",
    category_en: "Drilling",
    category_key: "forage",
    location: "Kananga, RDC",
    client: ""
  },
  {
    id: 12,
    image: "https://customer-assets.emergentagent.com/job_7e1961ac-5810-49fb-bfe1-8dd4c900e77c/artifacts/lk4mc228_pave4.jpeg",
    title_fr: "Direction de chantier - Supervision forage",
    title_en: "Site management - Drilling supervision",
    category_fr: "Forage",
    category_en: "Drilling",
    category_key: "forage",
    location: "Kananga, RDC",
    client: ""
  },
  {
    id: 13,
    image: "https://customer-assets.emergentagent.com/job_7e1961ac-5810-49fb-bfe1-8dd4c900e77c/artifacts/9ilk38cb_pave6.jpeg",
    title_fr: "Allée en pavés autobloquants finalisée",
    title_en: "Completed interlocking paver walkway",
    category_fr: "Pavage",
    category_en: "Paving",
    category_key: "pavage",
    location: "Kananga, RDC",
    client: ""
  },
  {
    id: 14,
    image: "https://customer-assets.emergentagent.com/job_7e1961ac-5810-49fb-bfe1-8dd4c900e77c/artifacts/yslk83q6_pave9.jpeg",
    title_fr: "Pose de pavés autobloquants en cours",
    title_en: "Interlocking paver installation in progress",
    category_fr: "Pavage",
    category_en: "Paving",
    category_key: "pavage",
    location: "Kananga, RDC",
    client: ""
  },
  {
    id: 15,
    image: "https://customer-assets.emergentagent.com/job_7e1961ac-5810-49fb-bfe1-8dd4c900e77c/artifacts/ymstm6ak_pave12.jpeg",
    title_fr: "Travaux de pavage avec caniveau",
    title_en: "Paving works with drainage channel",
    category_fr: "Pavage",
    category_en: "Paving",
    category_key: "pavage",
    location: "Kananga, RDC",
    client: ""
  },
];

const categories = [
  { key: 'all', label_fr: 'Tout', label_en: 'All' },
  { key: 'genie_civil', label_fr: 'Génie Civil', label_en: 'Civil Engineering' },
  { key: 'assainissement', label_fr: 'Assainissement', label_en: 'Drainage' },
  { key: 'pavage', label_fr: 'Pavage', label_en: 'Paving' },
  { key: 'forage', label_fr: 'Forage', label_en: 'Drilling' },
  { key: 'etudes', label_fr: 'Études', label_en: 'Studies' },
  { key: 'amenagement', label_fr: 'Aménagement', label_en: 'Landscaping' },
  { key: 'equipements', label_fr: 'Équipements', label_en: 'Equipment' },
];

export const GallerySection = () => {
  const { t, language } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const filteredPhotos = useMemo(() => {
    if (activeCategory === 'all') return allPhotos;
    return allPhotos.filter(p => p.category_key === activeCategory);
  }, [activeCategory]);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <section id="gallery" className="py-24 lg:py-32 bg-[#F8F9FA]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-[#FF6B00] text-xs sm:text-sm font-medium uppercase tracking-[0.2em] mb-4">
            {t.gallery.label}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1320] tracking-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="gallery-title"
          >
            {t.gallery.title}
          </h2>
          <p className="text-base text-[#475569] mt-4 max-w-xl mx-auto" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {t.gallery.subtitle}
          </p>
        </motion.div>

        {/* Category Filters */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-2 mb-12"
          data-testid="gallery-filters"
        >
          {categories.map((cat) => (
            <button
              key={cat.key}
              onClick={() => setActiveCategory(cat.key)}
              className={`px-5 py-2.5 text-xs font-medium uppercase tracking-wider transition-all duration-300 ${
                activeCategory === cat.key
                  ? 'bg-[#FF6B00] text-white'
                  : 'bg-white text-[#475569] hover:bg-[#0B1320] hover:text-white border border-black/10'
              }`}
              data-testid={`gallery-filter-${cat.key}`}
            >
              {language === 'fr' ? cat.label_fr : cat.label_en}
            </button>
          ))}
        </motion.div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {filteredPhotos.map((photo, index) => (
            <motion.div
              key={photo.id}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="group relative aspect-square overflow-hidden cursor-pointer"
              onClick={() => openLightbox(index)}
              data-testid={`gallery-photo-${index}`}
            >
              <img
                src={photo.image}
                alt={language === 'fr' ? photo.title_fr : photo.title_en}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-[#0B1320]/0 group-hover:bg-[#0B1320]/70 transition-all duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center px-3">
                  <MagnifyingGlass size={32} className="text-white mx-auto mb-2" weight="light" />
                  <p className="text-white text-sm font-medium" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                    {language === 'fr' ? photo.title_fr : photo.title_en}
                  </p>
                  <p className="text-[#FF6B00] text-xs uppercase tracking-wider mt-1">
                    {language === 'fr' ? photo.category_fr : photo.category_en}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        images={filteredPhotos}
        currentIndex={lightboxIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setLightboxIndex((prev) => (prev === 0 ? filteredPhotos.length - 1 : prev - 1))}
        onNext={() => setLightboxIndex((prev) => (prev === filteredPhotos.length - 1 ? 0 : prev + 1))}
        language={language}
      />
    </section>
  );
};
